import { useEffect, useState } from "react";
function ProgressBar({ progress, label }: any) {
    const [animatedProgress, setAnimatedProgress] = useState(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setAnimatedProgress(progress);
        }, 100);

        return () => clearTimeout(timeout);
    }, [progress]);

    return (
        <div className="w-full flex justify-evenly items-center">
            <div style={{ fontWeight: "bold" }}>{label}</div>
            <div
                style={{
                    width: "80%",
                    backgroundColor: "#e0e0df",
                    borderRadius: "8px",
                    height: "10px",
                }}
            >
                <div
                    style={{
                        width: `${animatedProgress}%`,
                        backgroundColor:
                            animatedProgress > 50 ? "#85ab6c" : "#2D667F",
                        height: "100%",
                        borderRadius: "8px",
                        textAlign: "center",
                        color: "white",
                        lineHeight: "10px",
                        transition: "width 1s ease-in-out",
                    }}
                ></div>
            </div>
            <p className="text-xs font-bold">{animatedProgress}%</p>
        </div>
    );
}

export default ProgressBar;
